import { render, staticRenderFns } from "./FeaturedData.vue?vue&type=template&id=d640a104"
import script from "./FeaturedData.vue?vue&type=script&lang=js"
export * from "./FeaturedData.vue?vue&type=script&lang=js"
import style0 from "./FeaturedData.vue?vue&type=style&index=0&id=d640a104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports